import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppScrollService {
  private mainScrollElement: Element;

  public setMainScrollElement(el: Element): void {
    this.mainScrollElement = el;
  }

  public scrollMainToTop(): void {
    if (this.mainScrollElement) {
      this.mainScrollElement.scrollTop = 0;
    }
  }

  public scrollMainToPosition(position: number): void {
    if (this.mainScrollElement) {
      this.mainScrollElement.scrollTop = position;
    }
  }

  public getMainScrollPosition(): number {
    return this.mainScrollElement ? this.mainScrollElement.scrollTop : 0;
  }
}
